<template>
  <div>
    <el-card class="page-container">
      <h1 class="title-biaoti">告警列表</h1>
      <el-row class="search">
        <el-input
          v-model="search.projectName"
          placeholder="请输入项目名称"
          style="width: 200px"
        ></el-input>
        <el-input
          v-model="search.warnName"
          placeholder="请输入告警名称"
          style="width: 200px"
        ></el-input>
        <el-button type="primary" @click="getAlarmList(true)">查询</el-button>
        <el-button type="waring" @click="addAlarmDialog = true">新增告警</el-button>
      </el-row>
      <el-row>
        <el-table :data="showList" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="createTime" label="创建时间" fixed> </el-table-column>
          <el-table-column prop="warnName" label="告警名"> </el-table-column>
          <el-table-column label="告警等级">
            <template slot-scope="scope">
              {{ levelLabel[scope.row.level] }}
            </template>
          </el-table-column>
          <el-table-column prop="opUser" label="创建用户"> </el-table-column>
          <el-table-column prop="person" label="告警责任方"> </el-table-column>
          <el-table-column prop="projectName" label="项目名"> </el-table-column>
          <el-table-column prop="weixinKey" label="企业微信机器人key"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="updateAlarm(scope.row)"
                type="text"
                size="small"
              >
                编辑
              </el-button>
              <el-button
                @click.native.prevent="deleteAlarm(scope.row.monitorId)"
                type="text"
                size="small"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="50"
          layout="total, prev, pager, next, jumper"
          :total="alarmList.length"
        ></el-pagination>
      </el-row>
    </el-card>
    <!-- 新增告警 -->
    <el-dialog
      title="新增告警"
      :visible.sync="addAlarmDialog"
      width="50%"
      :before-close="resetAddAlarmForm"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addAlarmForm"
        :rules="rules"
        ref="addAlarmForm"
        class="demo-ruleForm"
      >
        <el-form-item label="告警名" prop="addAlarmName">
          <el-input v-model="addAlarmForm.addAlarmName"></el-input>
        </el-form-item>
        <el-form-item label="告警等级">
          <el-select v-model="addAlarmForm.addAlarmLevel" placeholder="请选择告警等级">
            <el-option label="一般" :value="0"></el-option>
            <el-option label="重要" :value="1"></el-option>
            <el-option label="紧急" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名" prop="addAlarmProjectName">
          <el-input v-model="addAlarmForm.addAlarmProjectName"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="addAlarmPerson">
          <el-input v-model="addAlarmForm.addAlarmPerson"></el-input>
        </el-form-item>
        <el-form-item label="企业微信机器人key" prop="addAlarmWeixinKey">
          <el-input v-model="addAlarmForm.addAlarmWeixinKey"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetAddAlarmForm">取 消</el-button>
          <el-button type="primary" @click="doAddAlarm" v-loading="loading2"
            >新 增</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--编辑告警-->
    <el-dialog
      title="编辑告警"
      :visible.sync="updateAlarmDialog"
      width="50%"
      :before-close="resetUpdateAlarmForm"
    >
      <el-form
        :model="updateAlarmForm"
        :rules="rules2"
        ref="updateAlarmForm"
        class="demo-ruleForm"
      >
        <el-form-item label="告警名" prop="updateAlarmName">
          <el-input v-model="updateAlarmForm.updateAlarmName"></el-input>
        </el-form-item>
        <el-form-item label="告警等级">
          <el-select
            v-model="updateAlarmForm.updateAlarmLevel"
            placeholder="请选择告警等级"
          >
            <el-option label="一般" :value="0"></el-option>
            <el-option label="重要" :value="1"></el-option>
            <el-option label="紧急" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名" prop="updateAlarmProjectName">
          <el-input v-model="updateAlarmForm.updateAlarmProjectName"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="updateAlarmPerson">
          <el-input v-model="updateAlarmForm.updateAlarmPerson"></el-input>
        </el-form-item>
        <el-form-item label="企业微信机器人key" prop="updateAlarmWeixinKey">
          <el-input v-model="updateAlarmForm.updateAlarmWeixinKey"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetUpdateAlarmForm">取 消</el-button>
          <el-button type="primary" @click="doUpdateAlarm" v-loading="loading1"
            >编 辑</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--机器人-->
    <el-dialog
      title="编辑机器人列表"
      :visible.sync="rebotListDialog"
      width="50%"
      :before-close="closeRebotDialog"
    >
      <div style="margin-bottom: 20px">
        <el-button type="primary" @click="addRebotDialog = true">新增机器人</el-button>
      </div>
      <el-dialog
        width="50%"
        title="新增机器人"
        :visible.sync="addRebotDialog"
        :before-close="resetAddRobotForm"
        append-to-body
      >
        <el-form
          :model="addRobot"
          :rules="rules1"
          ref="addRobotForm"
          class="demo-ruleForm"
        >
          <el-form-item label="机器人key" prop="robotKey">
            <el-input v-model="addRobot.robotKey"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doAddRobot" v-loading="loading3"
              >新 增</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
      <div class="tags">
        <el-tag
          v-for="robot in robotList"
          :key="robot.robotId"
          @close.stop="removeRobat(robot.robotId)"
          closable
        >
          {{ robot.robotKey }}
        </el-tag>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //加载
      loading: false,
      loading1: false,
      loading2: false,
      loading3: false,
      alarmList: [],
      currentPage: 1,
      levelLabel: ["一般", "重要", "紧急"],
      search: { projectName: "", warnName: "" },
      // 新增告警
      addAlarmForm: {
        addAlarmName: "",
        addAlarmLevel: 2,
        addAlarmProjectName: "",
        addAlarmPerson: "",
        addAlarmWeixinKey: "",
      },
      // 修改告警
      updateAlarmForm: {
        updateAlarmId: "",
        updateAlarmName: "",
        updateAlarmLevel: 2,
        updateAlarmProjectName: "",
        updateAlarmPerson: "",
        updateAlarmWeixinKey: "",
      },
      // 新增机器人
      addRobot: {
        robotKey: "",
      },
      rules1: {
        robotKey: [
          {
            required: true,
            message: "请输入机器人key",
            trigger: "blur",
          },
        ],
      },
      rules: {
        addAlarmName: [
          {
            required: true,
            message: "请输入告警名",
            trigger: "blur",
          },
        ],
        addAlarmProjectName: [
          {
            required: true,
            message: "请输入项目名",
            trigger: "blur",
          },
        ],
        addAlarmPerson: [
          {
            required: true,
            message: "请输入负责人",
            trigger: "blur",
          },
        ],
      },
      rules2: {
        updateAlarmName: [
          {
            required: true,
            message: "请输入告警名",
            trigger: "blur",
          },
        ],
        updateAlarmProjectName: [
          {
            required: true,
            message: "请输入项目名",
            trigger: "blur",
          },
        ],
        updateAlarmPerson: [
          {
            required: true,
            message: "请输入负责人",
            trigger: "blur",
          },
        ],
      },
      // 查询机器人
      monitorId: "",
      robotList: [],
      // 弹窗
      addAlarmDialog: false,
      updateAlarmDialog: false,
      rebotListDialog: false,
      addRebotDialog: false,
    };
  },
  computed: {
    showList() {
      let start = (this.currentPage - 1) * 50;
      let end = this.currentPage * 50;
      return this.alarmList.slice(start, end);
    },
  },
  created() {
    this.getAlarmList();
  },
  methods: {
    // 查询列表
    async getAlarmList(bool) {
      this.loading = true;
      const { data: res } = await this.$axios({
        type: "GET",
        url: this.$store.getters.path.alarmList,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          projectName: this.search.projectName,
          warnName: this.search.warnName,
        },
      });
      this.loading = false;
      if (res.code != 0) return this.$message(res.msg);
      this.alarmList = res.data;
      if(bool) this.currentPage = 1
    },
    doUpdateAlarm() {
      this.$refs["updateAlarmForm"].validate(async (valid) => {
        if (valid) {
          let fordata = new FormData();
          fordata.append("username", this.$store.getters.username);
          fordata.append("token", this.$store.getters.token);
          fordata.append("monitorId", this.updateAlarmForm.updateAlarmId);
          fordata.append("warnname", this.updateAlarmForm.updateAlarmName);
          fordata.append("level", this.updateAlarmForm.updateAlarmLevel);
          fordata.append("projectName", this.updateAlarmForm.updateAlarmProjectName);
          fordata.append("person", this.updateAlarmForm.updateAlarmPerson);
          fordata.append("weixinKey", this.updateAlarmForm.updateAlarmWeixinKey);
          this.loading1 = true;
          const { data: res } = await this.$axios({
            method: "post",
            url: this.$store.getters.path.modifyAlarm,
            withCredentials: true,
            data: fordata,
          });
          this.loading1 = false;
          if (res.code != 0) {
            this.resetUpdateAlarmForm();
            return this.$message(res.msg);
          }
          this.resetUpdateAlarmForm();
          this.getAlarmList();
        } else {
          return false;
        }
      });
    },
    updateAlarm(row) {
      this.updateAlarmDialog = true;
      this.updateAlarmForm.updateAlarmId = row.monitorId;
      this.updateAlarmForm.updateAlarmName = row.warnName;
      this.updateAlarmForm.updateAlarmLevel = row.level;
      this.updateAlarmForm.updateAlarmProjectName = row.projectName;
      this.updateAlarmForm.updateAlarmPerson = row.person;
      this.updateAlarmForm.updateAlarmWeixinKey = row.weixinKey;
    },
    doAddAlarm() {
      this.$refs["addAlarmForm"].validate(async (valid) => {
        if (valid) {
          let fordata = new FormData();
          fordata.append("username", this.$store.getters.username);
          fordata.append("token", this.$store.getters.token);
          fordata.append("warnName", this.addAlarmForm.addAlarmName);
          fordata.append("level", this.addAlarmForm.addAlarmLevel);
          fordata.append("projectName", this.addAlarmForm.addAlarmProjectName);
          fordata.append("person", this.addAlarmForm.addAlarmPerson);
          fordata.append("weixinKey", this.addAlarmForm.addAlarmWeixinKey);
          this.loading2 = true;
          const { data: res } = await this.$axios({
            method: "post",
            url: this.$store.getters.path.createAlarm,
            withCredentials: true,
            data: fordata,
          });
          this.loading2 = false;
          if (res.code != 0) {
            this.resetAddAlarmForm();
            return this.$message(res.msg);
          }
          this.resetAddAlarmForm();
          this.getAlarmList();
        } else {
          return false;
        }
      });
    },
    deleteAlarm(id) {
      this.$confirm("确认删除此告警", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.$axios.post(
            this.$store.getters.path.deleteAlarm +
              "?username=" +
              this.$store.getters.username +
              "&token=" +
              this.$store.getters.token +
              "&monitorId=" +
              id,
            {}
          );
          if (res.code !== 0) return this.$message.error("删除失败");
          this.$message.success("删除成功");
          this.getAlarmList();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    resetAddAlarmForm() {
      this.$refs["addAlarmForm"].resetFields();
      this.addAlarmDialog = false;
    },
    resetUpdateAlarmForm() {
      this.$refs["updateAlarmForm"].resetFields();
      this.updateAlarmDialog = false;
    },
    resetAddRobotForm() {
      this.$refs["addRobotForm"].resetFields();
      this.addRebotDialog = false;
    },
    updateMonitor(id) {
      this.rebotListDialog = true;
      this.monitorId = id;
      this.findRobots();
    },
    async findRobots() {
      const { data: res } = await this.$axios({
        type: "GET",
        url: this.$store.getters.path.robotList,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          warnId: this.monitorId,
        },
      });
      if (res.code != 0) return this.$message(res.msg);
      this.robotList = res.data;
    },
    closeRebotDialog() {
      this.rebotListDialog = false;
      this.monitorId = "";
      this.robotList = [];
      this.getAlarmList();
    },
    async removeRobat(id) {
      let fordata = new FormData();
      fordata.append("username", this.$store.getters.username);
      fordata.append("token", this.$store.getters.token);
      fordata.append("warnId", this.monitorId);
      fordata.append("robotId", id);
      const { data: res } = await this.$axios({
        method: "post",
        url: this.$store.getters.path.deleteRobot,
        withCredentials: true,
        data: fordata,
      });
      if (res.code != 0) {
        return this.$message(res.msg);
      }
      this.findRobots();
    },
    doAddRobot() {
      this.$refs["addRobotForm"].validate(async (valid) => {
        if (valid) {
          let fordata = new FormData();
          fordata.append("username", this.$store.getters.username);
          fordata.append("token", this.$store.getters.token);
          fordata.append("warnId", this.monitorId);
          fordata.append("robotKey", this.addRobot.robotKey);
          this.loading3 = true;
          const { data: res } = await this.$axios({
            method: "post",
            url: this.$store.getters.path.createRobot,
            withCredentials: true,
            data: fordata,
          });
          this.loading3 = false;
          if (res.code != 0) {
            this.resetAddRobotForm();
            return this.$message(res.msg);
          }
          this.resetAddRobotForm();
          this.findRobots();
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss">
.search {
  display: flex;
  align-items: center;
  > * {
    margin: 0 5px;
  }
}
.el-form-item {
  display: flex;
}
.el-form-item__content {
  flex-grow: 1;
}
.el-form-item__label {
  width: 100px;
}
.tags span {
  display: inline-block;
  margin: 5px;
}
</style>
